import React from "react"
import HelmetGlobal from "./HelmetGlobal"
import HelmetSeo from "./HelmetSeo"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from 'prop-types'

export const Helmet = ({ location, pageProps, folder, alternatePages = null, seoIndex = true }) => {
  // console.log(pageProps)
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
            siteUrl
          }
        }
      }
    `
  )

  return <>
    <HelmetGlobal location={location} />
    <HelmetSeo
      location={location}
      title={pageProps.meta_title.text + (pageProps.exclude_fabrick === true ? "" : " | Fabrick")}
      description={pageProps.meta_description.text}
      image={pageProps.meta_image ? pageProps.meta_image.url : undefined}
      siteGraphQlData={site.siteMetadata}
      folder={folder}
      alternatePages={alternatePages ? alternatePages : null}
      seoIndex={seoIndex}
    />
  </>
}

Helmet.propTypes = {
  pageProps: PropTypes.shape({
    exclude_fabrick: PropTypes.bool,
    meta_title: PropTypes.shape({
      text: PropTypes.string
    })
  })
}

export default Helmet